<template>
  <section
    class="mx-auto w-full max-w-[1200px] mt-[90px] px-5 md:mt-[70px]"
    aria-labelledby="banner-frenos-title"
  >
    <div
      class="relative flex flex-col items-center gap-4 rounded-[12px] bg-[#C8102E] px-5 pb-6 pt-[55px] text-center shadow-[0_8px_24px_rgba(200,16,46,0.15)] md:flex-row md:flex-nowrap md:items-center md:justify-between md:gap-6 md:px-8 md:py-[26px]"
    >
      <!-- Imagen con sangrado vertical -->
      <img
        :src="image"
        :alt="imageAlt"
        class="relative z-[2] h-auto w-[140px] shrink-0 object-contain -mt-[95px] mb-3 md:h-[160px] md:w-[160px] md:-mt-[52px] md:-mb-[52px]"
        loading="eager"
        width="160"
        height="160"
      >

      <!-- Texto -->
      <div class="flex-1 px-0 text-center md:px-5">
        <h2
          id="banner-frenos-title"
          class="m-0 text-[clamp(1.1rem,2.5vw,1.4rem)] font-semibold leading-[1.3] text-white"
        >
          {{ title }}
        </h2>
        <p class="m-0 mt-[5px] text-[0.95rem] text-white/90">
          {{ description }}
        </p>
      </div>

      <!-- Botón -->
      <NuxtLink
        v-if="buttonUrl"
        :to="buttonUrl"
        class="inline-flex w-full shrink-0 items-center justify-center gap-[10px] whitespace-nowrap rounded-[8px] bg-white px-[26px] py-[13px] text-[0.98rem] font-semibold text-[#C8102E] no-underline transition-colors duration-200 hover:bg-[#FDF1F3] hover:text-[#A00D25] focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#C8102E] md:w-auto md:justify-start"
      >
        {{ buttonText }}
        <svg
          viewBox="0 0 24 24"
          class="h-4 w-4 fill-none stroke-current stroke-[2.4]"
          aria-hidden="true"
          focusable="false"
        >
          <path d="M7 17 17 7M9 7h8v8" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </NuxtLink>
      <button
        v-else
        type="button"
        class="inline-flex w-full shrink-0 items-center justify-center gap-[10px] whitespace-nowrap rounded-[8px] bg-white px-[26px] py-[13px] text-[0.98rem] font-semibold text-[#C8102E] transition-colors duration-200 hover:bg-[#FDF1F3] hover:text-[#A00D25] focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#C8102E] md:w-auto"
        @click="handleCtaClick"
      >
        {{ buttonText }}
        <svg
          viewBox="0 0 24 24"
          class="h-4 w-4 fill-none stroke-current stroke-[2.4]"
          aria-hidden="true"
          focusable="false"
        >
          <path d="M7 17 17 7M9 7h8v8" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>
  </section>
</template>

<script setup lang="ts">
interface Props {
  title?: string
  description?: string
  image?: string
  imageAlt?: string
  buttonText?: string
  buttonUrl?: string
}

withDefaults(
  defineProps<Props>(),
  {
    title: '¿Hace cuánto no revisas tus frenos?',
    description: 'Agenda gratis tu revisión en cualquiera de nuestros locales a lo largo de Chile.',
    image: '/img/frenos/image/frenos.png',
    imageAlt: 'Revisión de frenos',
    buttonText: 'Agenda tu revisión gratis',
    buttonUrl: ''
  }
)

function handleCtaClick() {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' })
}
</script>
